module.exports = __webpack_public_path__ + "bcccdadc189a559b67c61ae4c066cd2f.png";